// Enable prerendering for all pages - this is a fully static site
export const prerender = true;
